export function formatMoney(n?: number | null): string {
  if (n === null || n === undefined || isNaN(Number(n))) return '—';
  try {
    return Number(n).toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  } catch {
    return '$' + String(n);
  }
}

export function deltaBadge(n?: number | null): string {
  if (n === null || n === undefined || isNaN(Number(n))) return '—';
  const val = Number(n);
  const sign = val > 0 ? '▲' : val < 0 ? '▼' : '—';
  const abs = Math.abs(val);
  return `${sign} ${formatMoney(abs)}`;
}

export function formatDateISO(s?: string | null): string {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString(); } catch { return String(s); }
}

export function ordinal(value: number): string {
  const n = Math.abs(value);
  const suffix = n % 100 >= 11 && n % 100 <= 13 ? 'th' : ({1: 'st', 2: 'nd', 3: 'rd'} as Record<number, string>)[n % 10] || 'th';
  return `${value}${suffix}`;
}

// The API stores naive datetimes in UTC; explicit offsets must be preserved.
export function utcDate(value: string): Date {
  return new Date(/^\d{4}-\d{2}-\d{2}T/.test(value) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value) ? `${value}Z` : value);
}
